import React, { useMemo } from 'react';

import { usePetitionDetailsPageData } from 'src/app/pages/petitionGamma/details/pageContext';
import { Html } from 'src/app/shared/components/html';
import { useRichMediaTransformers } from 'src/app/shared/hooks/richMedia';

import { useDescriptionTracking } from '../../../../hooks/tracking/description';

export const DescriptionContent: React.FC = () => {
	const { trackClickLink } = useDescriptionTracking();

	const {
		data: {
			petition: { description },
		},
	} = usePetitionDetailsPageData();

	const { decodeRichMediaTransformer } = useRichMediaTransformers();
	const htmlTransformers = useMemo(() => [decodeRichMediaTransformer], [decodeRichMediaTransformer]);

	return (
		<div data-qa="description-content" data-testid="description-html-content">
			<Html
				size="default"
				variant="body"
				breakWord
				html={description}
				className="leading-[28px] [&>iframe]:aspect-video [&>iframe]:h-auto [&>iframe]:w-full"
				transformers={htmlTransformers}
				onClickLink={trackClickLink}
				expressive
			/>
		</div>
	);
};
